import { useState } from 'react';
import type { ResultadoPago } from '@medchoice/shared';
import { ApiError } from '../../api/client';
import { paciente } from '../../api/paciente';
import { irA } from '../../router';
import { AvisoError, Boton, EstadoVacio, OpcionTarjeta, Tarjeta } from '../../ui';
import { pesos } from '../../ui/format';
import { leerReserva, olvidarReserva } from './reservaPendiente';

const RESULTADOS: { resultado: ResultadoPago; titulo: string; detalle: string }[] = [
  { resultado: 'aprobado', titulo: 'Pago aprobado', detalle: 'El turno queda confirmado.' },
  { resultado: 'en_revision', titulo: 'Pago en revisión', detalle: 'El turno queda pendiente hasta que se acredite.' },
  { resultado: 'rechazado', titulo: 'Pago rechazado', detalle: 'No se reserva nada y volvés a elegir el medio de pago.' },
];

/**
 * Pasarela simulada, igual que en el prototipo: en la demostración se elige a
 * mano qué responde el medio de pago. En producción es el checkout de MercadoPago.
 */
export function Pago() {
  const [pendiente] = useState(leerReserva);
  const [resultado, setResultado] = useState<ResultadoPago>('aprobado');
  const [error, setError] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  if (!pendiente) {
    return <EstadoVacio icono="credit-card" titulo="No hay ningún pago en curso"
      accion={<Boton onClick={() => irA('/buscar')}>Buscar profesionales</Boton>} />;
  }

  const pagar = async () => {
    setEnviando(true);
    setError(null);
    try {
      const turno = await paciente.reservar({ ...pendiente.reserva, resultado_pago: resultado });
      olvidarReserva();
      irA(`/confirmacion/${turno.id_turno}`, { reemplazar: true });
    } catch (e) {
      if (resultado === 'rechazado') {
        irA(`/reservar/${pendiente.reserva.profesional}?servicio=${pendiente.reserva.servicio}&pago=rechazado`, { reemplazar: true });
        return;
      }
      setError(e instanceof ApiError ? e.message : 'No pudimos procesar el pago. Probá de nuevo.');
      setEnviando(false);
    }
  };

  return (
    <div className="pago">
      <Tarjeta>
        <span className="eyebrow">Pasarela de pago · demostración</span>
        <h1 className="pago__titulo">Seña de {pesos(pendiente.sena)}</h1>
        <p className="pago__detalle">{pendiente.servicio} con {pendiente.profesional}</p>
        <AvisoError>{error}</AvisoError>
        <fieldset className="reserva__grupo">
          <legend>¿Qué responde el medio de pago?</legend>
          {RESULTADOS.map((r) => (
            <OpcionTarjeta key={r.resultado} name="resultado" checked={resultado === r.resultado}
              onChange={() => setResultado(r.resultado)} titulo={r.titulo} detalle={r.detalle} />
          ))}
        </fieldset>
        <Boton anchoCompleto tamano="grande" cargando={enviando} onClick={() => void pagar()}>Pagar</Boton>
      </Tarjeta>
    </div>
  );
}
